import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const H1Icon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "H1",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M23.91 6.1h1.98v11.22a1.987 1.987 0 0 0 3.96.01V4.13c0-1.1-.89-1.98-1.98-1.98h-3.96a1.987 1.987 0 0 0-.01 3.96ZM4.14 29.85c1.1 0 1.98-.89 1.98-1.98v-9.88h9.23v10.03c0 1.1.89 1.98 1.98 1.98s1.98-.89 1.98-1.98V3.99c0-1.1-.89-1.98-1.98-1.98s-1.98.89-1.98 1.98v10.04H6.11V3.99c0-1.1-.89-1.98-1.98-1.98s-1.98.89-1.98 1.98v23.88c0 1.1.89 1.98 1.98 1.98Z"
      })
    }) : /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M19.44 3.43a1.14 1.14 0 1 0-2.28 0v11.43H4.58V3.43a1.14 1.14 0 1 0-2.28 0v25.14a1.14 1.14 0 1 0 2.28 0V17.14h12.57v11.43a1.14 1.14 0 1 0 2.28 0V3.43ZM27.71 2.29c-.44 1.65-1.73 2.63-3.7 2.78v2.21c1.56-.15 2.7-.89 3.41-1.67v13.91h2.29V2.29z"
      })
    })
  }));
};
H1Icon.displayName = 'H1Icon';